const getMenuCookie = (_menu) => {
    let routes = [];
    let menu = _menu.menu ? _menu.menu : _menu;
    menu.forEach(item =>{
        if (item.children && item.children.length) {
            routes.push({
                path: item.path,
                name: item.name.toLowerCase(),
                label: item.label,
                icon: item.icon,
                is_public: item.is_public,
                is_menu: item.is_menu,
                color: item.color ?? '',
                priority: item.priority ?? '',
                quick_identification_code: item.quick_identification_code,
                component: () => import(`@/${item.folder}/views/${item.component}.vue`),
                meta: {
                    requiresAuth: true,
                    title: item.label,
                    icon: item.icon,
                    is_children: false,
                }
            });

            if (item.children && item.children.length) {
                item.children.forEach(child =>{
                    routes.push({
                        path: child.path,
                        name: child.name.toLowerCase(),
                        label: item.label,
                        component: () => import(`@/${child.folder}/views/${child.component}.vue`),
                        is_public: item.is_public,
                        is_menu: item.is_menu,
                        color: child.color ?? '',
                        priority: child.priority ?? '',
                        quick_identification_code: child.quick_identification_code,
                        meta: {
                            requiresAuth: true,
                            title: child.label,
                            icon: child.icon,
                            is_children: true,
                        },
                    });
                });

            }
        }else{

            routes.push({
                path: item.path,
                name: item.name.toLowerCase(),
                label: item.label,
                icon: item.icon,
                component: ()=>import(`@/${item.folder}/views/${item.component}.vue`),
                is_public: item.is_public,
                is_menu: item.is_menu,
                color: item.color ?? '',
                priority: item.priority ?? '',
                quick_identification_code: item.quick_identification_code,
                meta: {
                    requiresAuth: true,
                    title: item.label,
                    icon: item.icon,
                    is_children: false,
                },
            });

        }
    });

    // console.log("routes ", routes);
    return routes;
}

export default getMenuCookie;